import React, { useState } from "react";
import { Box, Container, Typography, CardMedia, Button } from "@mui/material";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";

const Slogans = () => {
  const { t } = useTranslation();
  const slogans = t("slogans.list", { returnObjects: true });
  const [showAll, setShowAll] = useState(false);

  const visibleSlogans = showAll ? slogans : slogans.slice(0, 10);

  return (
    <Box sx={{ backgroundColor: "#FFF8E1", py: { xs: 4, md: 8 } }}>
      <Container maxWidth="xl">
        {/* 🔱 Title */}
        <Typography
          variant="h3"
          align="center"
          sx={{
            fontWeight: 700,
            mb: 6,
            color: "#000",
          }}
        >
          {t("slogans.title")}
        </Typography>

        {/* 🕉️ Slogans List */}
        {visibleSlogans.map((item, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <Box
              component={motion.div}
              whileHover={{
                scale: 1.03,
                boxShadow: "0 0 40px rgba(255, 215, 0, 0.6)",
              }}
              transition={{ type: "spring", stiffness: 120, damping: 10 }}
              sx={{
                display: "flex",
                flexDirection: {
                  xs: "column",
                  md: index % 2 === 0 ? "row" : "row-reverse",
                },
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "#000",
                color: "#FFD700",
                borderRadius: "24px",
                boxShadow: "0 8px 24px rgba(255,215,0,0.3)",
                overflow: "hidden",
                mb: 6,
                width: "100%",
                maxWidth: "1200px",
                mx: "auto",
                cursor: "pointer",
                transition: "all 0.3s ease-in-out",
              }}
            >
              {/* 🖼️ Image */}
              <CardMedia
                component="img"
                image={item.image}
                alt={`Slogan ${index + 1}`}
                sx={{
                  width: { xs: "120%", md: "50%" },
                  height: { xs: "280px", md: "300px" },
                  objectFit: "fill",
                  filter: "brightness(0.95)",
                }}
              />

              {/* ✨ Text */}
              <Box
                sx={{
                  flex: 1,
                  p: { xs: 3, md: 5 },
                  textAlign: "center",
                  fontSize: { xs: "1.1rem", md: "1.3rem" },
                  lineHeight: 1.8,
                  fontWeight: 500,
                  color: "#FFD700",
                  whiteSpace: "pre-line",
                  textShadow: "0 0 12px rgba(255,215,0,0.6)",
                }}
              >
                {item.text}
              </Box>
            </Box>
          </motion.div>
        ))}

        {/* 🔘 Show More / Less Button */}
        {slogans.length > 10 && (
          <Box textAlign="center" mt={4}>
            <Button
              variant="contained"
              onClick={() => setShowAll(!showAll)}
              sx={{
                backgroundColor: "#FFD700",
                color: "#000",
                fontWeight: 700,
                px: 4,
                py: 1.2,
                borderRadius: "50px",
                textTransform: "none",
                "&:hover": {
                  backgroundColor: "#FFC300",
                  boxShadow: "0 0 20px rgba(255, 215, 0, 0.6)",
                },
              }}
            >
              {showAll ? t("showLess", "Show Less") : t("showMore", "Show More")}
            </Button>
          </Box>
        )}
      </Container>
    </Box>
  );
};

export default Slogans;
